import React from 'react';

export const FlameIcon = ({ className }) => (
  <svg 
    className={className || 'h-5 w-5'} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M12 23C16.9706 23 21 18.9706 21 14C21 9.02944 17.5 7 15.5 2C15.5 6 14 7.5 12 8.5C10 6.5 9.5 4 9.5 2C7.5 7 3 9.02944 3 14C3 18.9706 7.02944 23 12 23Z" 
      fill="currentColor"
    />
  </svg>
);

export const SparklesIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M19.5 9.5C19.5 10.3284 18.8284 11 18 11C17.1716 11 16.5 10.3284 16.5 9.5C16.5 8.67157 17.1716 8 18 8C18.8284 8 19.5 8.67157 19.5 9.5Z" 
      fill="currentColor"
    />
    <path 
      d="M19.5 15.5C19.5 16.3284 18.8284 17 18 17C17.1716 17 16.5 16.3284 16.5 15.5C16.5 14.6716 17.1716 14 18 14C18.8284 14 19.5 14.6716 19.5 15.5Z" 
      fill="currentColor"
    />
    <path 
      d="M13.5 12.5C13.5 13.3284 12.8284 14 12 14C11.1716 14 10.5 13.3284 10.5 12.5C10.5 11.6716 11.1716 11 12 11C12.8284 11 13.5 11.6716 13.5 12.5Z" 
      fill="currentColor"
    />
    <path 
      d="M13.5 18.5C13.5 19.3284 12.8284 20 12 20C11.1716 20 10.5 19.3284 10.5 18.5C10.5 17.6716 11.1716 17 12 17C12.8284 17 13.5 17.6716 13.5 18.5Z" 
      fill="currentColor"
    />
    <path 
      d="M7.5 15.5C7.5 16.3284 6.82843 17 6 17C5.17157 17 4.5 16.3284 4.5 15.5C4.5 14.6716 5.17157 14 6 14C6.82843 14 7.5 14.6716 7.5 15.5Z" 
      fill="currentColor"
    />
    <path 
      d="M7.5 9.5C7.5 10.3284 6.82843 11 6 11C5.17157 11 4.5 10.3284 4.5 9.5C4.5 8.67157 5.17157 8 6 8C6.82843 8 7.5 8.67157 7.5 9.5Z" 
      fill="currentColor"
    />
    <path 
      d="M13.5 6.5C13.5 7.32843 12.8284 8 12 8C11.1716 8 10.5 7.32843 10.5 6.5C10.5 5.67157 11.1716 5 12 5C12.8284 5 13.5 5.67157 13.5 6.5Z" 
      fill="currentColor"
    />
  </svg>
);

export const TrophyIcon = ({ className }) => (
  <svg 
    className={className || 'h-5 w-5'} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 9 L18 9 L18 12 Q18 15 12 15 Q6 15 6 12 L6 9" />
    <path d="M6 9 L4 9 Q2 9 2 11 Q2 13 4 13 L6 13" />
    <path d="M18 9 L20 9 Q22 9 22 11 Q22 13 20 13 L18 13" />
    <path d="M10 15 L10 18 L14 18 L14 15" />
    <path d="M8 21 L16 21" />
  </svg>
);

export const CalendarIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M16 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M8 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M3 10H21" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const StarIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" 
      fill="currentColor"
    />
  </svg>
);

export const LockIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V11" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const QuestionMarkIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="M12 16V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 14C12 11 15 11.5 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const LevelUpIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 3L20 10H15V21H9V10H4L12 3Z" fill="currentColor" />
  </svg>
);

// New icons for feature-specific badges

export const AiDetectIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" 
      fill="currentColor"
    />
  </svg>
);

export const HumanizeIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" 
      fill="currentColor"
    />
  </svg>
);

export const PlagiarismIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM12 18C10.34 18 9 16.66 9 15C9 13.34 10.34 12 12 12C13.66 12 15 13.34 15 15C15 16.66 13.66 18 12 18ZM12 10C10.34 10 9 8.66 9 7C9 5.34 10.34 4 12 4C13.66 4 15 5.34 15 7C15 8.66 13.66 10 12 10Z" 
      fill="currentColor"
    />
  </svg>
);

export const TripleThreatIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M3 11H11V3H3V11ZM5 5H9V9H5V5Z" 
      fill="currentColor"
    />
    <path 
      d="M13 3V11H21V3H13ZM19 9H15V5H19V9Z" 
      fill="currentColor"
    />
    <path 
      d="M3 21H11V13H3V21ZM5 15H9V19H5V15Z" 
      fill="currentColor"
    />
    <path 
      d="M18 21H16V17H14V15H16V13H18V15H20V17H18V21Z" 
      fill="currentColor"
    />
  </svg>
);

export const BalancedIcon = ({ className }) => (
  <svg 
    className={className} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M13 7H11V9H13V7ZM13 11H11V17H13V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" 
      fill="currentColor"
    />
  </svg>
); 